import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PrescriptionMedication } from "src/api/types";
import { useMedicationInstructions } from "src/hooks/useMedicationInstruction";

interface Props {
  detail: PrescriptionMedication;
  selected: number;
  category: string;
}

const MedicationInstruction = ({ detail, selected, category }: Props) => {
  const { t } = useTranslation();
  const { instruction } = useMedicationInstructions(detail, selected);
  const medication = useMemo(() => detail.medications[0], [detail.medications]);
  const dosage = useMemo(() => {
    const dosageUnit = medication?.dosage?.replace(/\d+([,.]\d+)?/g, "");
    const amount = detail.medications.reduce(
      (acc, m) => acc + parseFloat(m.dosage),
      0
    );

    if (dosageUnit === "N/A" || category === "Erectile Dysfunction") return "";

    return `[${amount} ${dosageUnit}]`;
  }, [category, detail.medications, medication?.dosage]);

  return (
    <>
      <Typography>{`${t(
        `medications.${medication.display_name?.toLowerCase()}.capitalized`,
        medication.display_name || ""
      )} ${dosage}`}</Typography>
      <Typography>{instruction}</Typography>
    </>
  );
};

export default MedicationInstruction;
